import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { api } from '../../lib/api';
import { Button } from '../ui/button';
import { SectionCard } from '../pipeline/ui';
import { formatCreditsOnly } from '../../lib/credits';

// Self-serve bundle purchase. Renders ONLY when the instance allows external payments and at
// least one Rial-priced bundle exists; the server re-checks both on checkout, so this gate is
// display-only (the manifest-is-decoration rule). Users see credits + Rial — never dollars.
export default function BuyBundlesCard() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    api.walletBundles().then(setData).catch(() => setData(null));
  }, []);

  if (!data?.external_payments_enabled || !(data.bundles || []).length) return null;

  const buy = async (id) => {
    setBusyId(id);
    try {
      const r = await api.walletCreateCheckout(id);
      // Off to the gateway; the callback lands the buyer back on /settings/billing?payment=…
      window.location.assign(r.redirect_url);
    } catch (e) {
      toast.error(t('wallet.payFailed'));
      setBusyId(null);
    }
  };

  return (
    <SectionCard title={t('wallet.buyTitle')} testId="buy-bundles-card">
      {!data.gateway_ready && (
        <p className="mb-3 text-sm text-muted-foreground" data-testid="buy-gateway-not-ready">
          {t('wallet.gatewayNotReady')}
        </p>
      )}
      <ul className="flex flex-col gap-2">
        {data.bundles.map((b) => (
          <li
            key={b.id}
            className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-border px-3.5 py-2.5"
            data-testid={`buy-bundle-${b.id}`}
          >
            <span className="text-sm">
              <span className="font-bold">{b.label}</span>
              <span className="ms-2 text-muted-foreground" data-testid={`buy-bundle-credits-${b.id}`}>
                {t('wallet.credits', { balance: formatCreditsOnly(b.credits) })}
              </span>
            </span>
            <span className="flex items-center gap-3">
              <span className="font-data text-sm" data-testid={`buy-bundle-price-${b.id}`}>
                {Number(b.price_irr).toLocaleString()} {t('wallet.rial')}
              </span>
              <Button
                onClick={() => buy(b.id)}
                disabled={!data.gateway_ready || busyId != null}
                data-testid={`buy-bundle-btn-${b.id}`}
              >
                {t('wallet.buy')}
              </Button>
            </span>
          </li>
        ))}
      </ul>
    </SectionCard>
  );
}
